/** Shared appearance notifications; no React or native runtime dependency. */
/**
 * Shared preference-change notifier. `setTenantThemeModePreference` (in
 * `useTenantTheme.ts`) notifies these listeners when the user changes the
 * stored appearance preference; `useResolvedThemeMode` subscribes so Paper,
 * navigation, StatusBar and tenant-colour consumers all re-resolve together.
 */
const themeModeListeners = new Set();
/** Subscribe to preference changes; returns the unsubscribe function. */
export function subscribeToThemeModeChanges(listener) {
    themeModeListeners.add(listener);
    return () => {
        themeModeListeners.delete(listener);
    };
}
/** Notify all subscribers that the stored preference changed. */
export function notifyThemeModeChanged() {
    themeModeListeners.forEach(listener => listener());
}
